import { lazy, Suspense, useContext, useState } from "react";
import { ParallaxProvider } from "react-scroll-parallax";
import "./App.scss";
import Intro from "./views/Intro/Intro";
import UserChoices from "./views/UserChoices/UserChoices";
import Cards from "./views/Cards/Cards";
import Vitrine from "./views/Vitrine/Vitrine";
import Contact from "./views/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { ThemeModeContext } from "./contexts/ThemeModeContext";
const PersoApp = lazy(() => import("./views/Perso/PersoApp"));
const CaloriesApp = lazy(() => import("./views/Calories/CaloriesApp"));

function App() {
  const initialThemeMode = useContext(ThemeModeContext);
  const [themeMode, setThemeMode] = useState(initialThemeMode);

  if (/^\/calories?(\/|$)/.test(window.location.pathname)) {
    return <Suspense fallback={<div style={{ padding: "2rem" }}>Chargement du journal…</div>}><CaloriesApp /></Suspense>;
  }

  if (window.location.pathname === "/perso" || window.location.pathname.startsWith("/perso/")) {
    return <Suspense fallback={<div style={{ padding: "2rem" }}>Chargement de l’espace personnel…</div>}><PersoApp /></Suspense>;
  }

  return (
    <ThemeModeContext.Provider value={{ themeMode, setThemeMode }}>
      <ParallaxProvider>
        <div className={`${themeMode}`}>
          <UserChoices />
          <Intro />
          <Cards />
          <Vitrine />
          <Contact />
          <Footer />
        </div>
      </ParallaxProvider>
    </ThemeModeContext.Provider>
  );
}

export default App;
